var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupaboloBoxLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1500 400",
    style: {
      enableBackground: "new 0 0 1500 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t\t.st0 {\r\n\t\t\tfill: #FFFFFF;\r\n\t\t\tstroke: #000000;\r\n\t\t\tstroke-miterlimit: 10;\r\n\t\t}\r\n\r\n\t\t.st1 {\r\n\t\t\tfill: #EC2026;\r\n\t\t}\r\n\r\n\t\t.st2 {\r\n\t\t\tfill: #FFFFFF;\r\n\t\t}\r\n\r\n\t\t.st3 {\r\n\t\t\tfont-family: 'FuturaBT-BoldItalic';\r\n\t\t}\r\n\r\n\t\t.st4 {\r\n\t\t\tfont-size: 328px;\r\n\t\t}\r\n\r\n\t\t.st5 {\r\n\t\t\tletter-spacing: -20;\r\n\t\t}\r\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    className: "st1",
    width: 1500,
    height: 400
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 45 295)",
    className: "st2 st3 st4 st5"
  }, "Supabolo"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupaboloBoxLogo);
export default __webpack_public_path__ + "static/media/Supabolo Box Logo.01c45ad04374637a10a77a1b62ec8b08.svg";
export { ForwardRef as ReactComponent };